import { c as _c } from "react/compiler-runtime";
import * as RadioGroup from '@radix-ui/react-radio-group';
import noop from 'lodash/noop';
import Label from '../label';
import type { GroupedRadioSelectOptionFields, RadioSelectOptionFields } from './components/radio-select-option';
import RadioSelectOption from './components/radio-select-option';
export type RadioSelectProps = {
  label?: string;
  onChange?: (value: string) => void;
  options: RadioSelectOptionFields[] | GroupedRadioSelectOptionFields[];
  size?: 'compact' | 'default';
  testID?: string;
  value?: string;
};
const RadioSelect = t0 => {
  const $ = _c(19);
  const {
    label,
    onChange,
    options,
    size: t1,
    testID,
    value
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== label) {
    t2 = label && <Label>{label}</Label>;
    $[0] = label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onChange || $[3] !== options || $[4] !== size || $[5] !== value) {
    let t4;
    if ($[7] !== onChange || $[8] !== size || $[9] !== value) {
      t4 = option => {
        if ("label" in option) {
          return <div key={option.label} className="flex flex-col gap-3 not-first:mt-4"><p className="truncate text-secondary text-label-2">{option.label}</p>{option.options.map(subOption => <RadioSelectOption key={subOption.value} value={subOption.value} title={subOption.title} description={subOption.description} IconComponent={subOption.IconComponent} disabled={subOption.disabled} disabledHint={subOption.disabledHint} onClick={subOption.disabled ? noop : () => onChange?.(subOption.value)} selected={subOption.value === value} size={size} />)}</div>;
        }
        return <RadioSelectOption key={option.value} value={option.value} title={option.title} description={option.description} IconComponent={option.IconComponent} disabled={option.disabled} disabledHint={option.disabledHint} onClick={option.disabled ? noop : () => onChange?.(option.value)} selected={option.value === value} size={size} />;
      };
      $[7] = onChange;
      $[8] = size;
      $[9] = value;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = options.map(t4);
    $[2] = onChange;
    $[3] = options;
    $[4] = size;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[11] !== t3 || $[12] !== testID) {
    t4 = <div data-testid={testID} className="flex flex-col gap-2 data-[tooltip-trigger='true']:w-full">{t3}</div>;
    $[11] = t3;
    $[12] = testID;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== onChange || $[15] !== t2 || $[16] !== t4 || $[17] !== value) {
    t5 = <RadioGroup.Root value={value} onValueChange={onChange}>{t2}{t4}</RadioGroup.Root>;
    $[14] = onChange;
    $[15] = t2;
    $[16] = t4;
    $[17] = value;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default RadioSelect;